enum UserStatus {
  Rejected = 'rejected',
  Revoked = 'revoked',
  Active = 'active',
  Inactive = 'inactive',
  AwaitingApproval = 'awaiting_approval',
}

export default UserStatus;
